import { Common } from '../common';
import {
  BaseUserGroup,
  UserGroup,
  UserGroupWithDetails,
} from '../models/user/group';
import { Permission } from '../models/group';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async create(toAdd: BaseUserGroup, ticketUrl: string): Promise<UserGroup> {
    const url = this.common.constructPath('/user-groups');
    return this.common.postJSON(url, { ...toAdd, ticketUrl });
  }

  async remove(id: string, ticketUrl: string): Promise<boolean> {
    const url = this.common.constructPath(
      `/user-groups/${id}?ticketUrl=${ticketUrl}`,
    );
    const { success } = await this.common.deleteJSON(url);
    return success;
  }

  async findMyUserGroups(): Promise<UserGroupWithDetails[]> {
    const url = this.common.constructPath('/user-groups/me');
    const { userGroups } = await this.common.getJSON(url);
    return userGroups;
  }

  async myPermissions(): Promise<Permission[]> {
    const groups = await this.findMyUserGroups();
    return groups
      .map((g) => g.permissions)
      .reduce((accum, perms) => [...accum, ...perms], []);
  }
}
